import { PurchaseOrderReturnPanel } from './PurchaseOrderReturnPanel';

export default PurchaseOrderReturnPanel;
